export default "__VITE_ASSET__Dw4$srAR__"